// extracted by mini-css-extract-plugin
module.exports = {"select-lang":"SelectLang_select-lang__3gtJb","select-item":"SelectLang_select-item__2Dv5q"};